module.exports = __webpack_public_path__ + "img/deposit.54c5aa7b.svg";